export const selfCheckout = 'self-checkout-flow';

export default selfCheckout;
